import {alpha, createTheme} from "@mui/material";
import React from "react";


export const theme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ownerState}) => ({
                    ...(ownerState.variant === "contained" &&
                    ownerState.color === "primary"
                        ? {
                            backgroundColor: theme.palette.secondary.main,
                            // borderRadius: "5px",
                            // fontSize: "20px",
                            // fontWeight: 600,
                            color: "#FFF",
                            textTransform: "capitalize",
                            // justifyContent: "center",
                            // alignItems: "center",

                            transition: theme.transitions.create([
                                "border-color",
                                "background-color",
                                "box-shadow",
                            ]),

                            // "&:focus, &:hover": {
                            //     boxShadow: `${alpha(
                            //         theme.palette.primary.main,
                            //         0.9
                            //     )} 0 0 0 0.2rem`,
                            //     borderColor: theme.palette.primary.main,
                            //     color: "#2398AB",
                            //     backgroundColor: theme.palette.primary.light,
                            // },

                            // ".Mui-disabled": {
                            //     color: "#fff",
                            //     backgroundColor: "#fff",
                            // },
                        }
                        : ownerState.color === "secondary"
                            ? {
                                // width: "100%",
                                // height: "50px",
                                // backgroundColor: theme.palette.primary.light,
                                // borderRadius: "5px",
                                // fontSize: "20px",
                                // fontWeight: 400,
                                // color: theme.palette.primary.main,
                                // textTransform: "none",
                                // justifyContent: "center",
                                // alignItems: "center",
                                //
                                // transition: theme.transitions.create([
                                //     "border-color",
                                //     "background-color",
                                //     "box-shadow",
                                // ]),
                                //
                                // "&:focus, &:hover": {
                                //     boxShadow: `${alpha(
                                //         theme.palette.primary.light,
                                //         1
                                //     )} 0 0 0 0.2rem`,
                                //     borderColor: theme.palette.primary.light,
                                //     color: "#FFF",
                                //     backgroundColor: theme.palette.primary.main,
                                // },
                                //
                                // ".Mui-disabled": {
                                //     color: "#fff",
                                //     backgroundColor: "#fff",
                                // },
                            }
                            : ownerState.color === "error"
                                ? {
                                    // width: "100%",
                                    // height: "50px",
                                    // backgroundColor: theme.palette.error.light,
                                    // borderRadius: "5px",
                                    // fontSize: "20px",
                                    // fontWeight: 400,
                                    color: theme.palette.error.main,
                                    // textTransform: "none",
                                    // justifyContent: "center",
                                    // alignItems: "center",

                                    transition: theme.transitions.create([
                                        "border-color",
                                        "background-color",
                                        "box-shadow",
                                    ]),

                                    // "&:focus, &:hover": {
                                    //     boxShadow: `${alpha(
                                    //         theme.palette.error.light,
                                    //         0.9
                                    //     )} 0 0 0 0.2rem`,
                                    //     borderColor: theme.palette.error.light,
                                    //     color: "#FFF",
                                    //     backgroundColor: theme.palette.error.main,
                                    // },
                                    //
                                    // ".Mui-disabled": {
                                    //     color: "#fff",
                                    //     backgroundColor: "#fff",
                                    // },
                                }
                                : ownerState.color === "inherit"
                                    ? {
                                        // width: "100%",
                                        // height: "50px",
                                        backgroundColor: theme.palette.secondary.main,
                                        // borderRadius: "5px",
                                        // fontSize: "20px",
                                        // fontWeight: 400,
                                        // color: theme.palette.primary.main,
                                        // textTransform: "none",
                                        // justifyContent: "center",
                                        // alignItems: "center",
                                        //
                                        // transition: theme.transitions.create([
                                        //     "border-color",
                                        //     "background-color",
                                        //     "box-shadow",
                                        // ]),
                                        //
                                        // "&:focus, &:hover": {
                                        //     boxShadow: `${alpha(
                                        //         theme.palette.primary.main,
                                        //         0.9
                                        //     )} 0 0 0 0.2rem`,
                                        //     borderColor: theme.palette.error.main,
                                        //     color: theme.palette.primary.main,
                                        //     backgroundColor: theme.palette.primary.light,
                                        // },
                                        //
                                        // ".Mui-disabled": {
                                        //     color: "#fff",
                                        //     backgroundColor: "#fff",
                                        // },
                                    }
                                    : {}),
                }),
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    backgroundColor: "primary.main",
                    "&.Mui-selected": {       // this is to refer to the prop provided by M-UI
                        backgroundColor: "#5BA0CE",
                        color: "#fff", // updated backgroundColor
                        "&.Mui-focusVisible": {background: "#5BA0CE", color: "#fff",}
                    },

                },

            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    color: "secondary.light",
                    "&.Mui-selected": {       // this is to refer to the prop provided by M-UI
                        color: "#FFE600", // updated backgroundColor
                        borderColor: "#FFE600",
                        "&.Mui-focusVisible": {background: "#FFE600"}
                    },
                    indicatorColor: {
                        backgroundColor: "#666666"
                    }

                },

            }
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: "#FFE600"
                }

            }
        }

    },
    typography: {
        fontFamily: ["Proxima Nova", "sans-serif", "Gilroy"].join(","),


    },
    palette: {
        primary: {
            main: "#5BA0CE",
            light: "#8A98AA",
            dark: "#7D8CA0"
        },
        secondary: {
            main: "#5BA0CE",
            light: "#fff",


        },
        error: {
            main: "#FD4444",
            light: "#FD4444",
        },
        text: {
            primary: "#7D8CA0",
            secondary: "#8A98AA",

        },

    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 425,
            md: 768,
            lg: 1024,
            xl: 1280,
        },
    },
});

export default createTheme;
